/**
 * The `entityRef` widget. Entity choices come from the widget environment
 * (the Inspector lists the level's entities), so the widget never reads the
 * world itself. The `assetRef` widget is the asset picker (AssetPicker.tsx).
 */
import type { PropType } from "../../world/schema/propTypes";
import { FieldError, fieldAria } from "./fieldAria";
import { isMixed, MIXED_OPTION, MixedOption } from "./mixed";
import type { WidgetProps } from "./types";
import { useWidgetEnvironment } from "./WidgetEnvironment";

export function EntityRefWidget({
  id,
  label,
  prop,
  value,
  onChange,
  onCommit,
  error,
}: WidgetProps) {
  const { requires } = prop as Extract<PropType, { type: "entityRef" }>;
  const options = useWidgetEnvironment().entityOptions(requires);

  return (
    <span className="kn-field">
      <select
        id={id}
        className="kn-input kn-select"
        aria-label={label}
        value={isMixed(value) ? MIXED_OPTION : typeof value === "string" ? value : ""}
        disabled={prop.readonly === true}
        {...fieldAria(id, error)}
        onChange={(event) => {
          onChange(event.target.value === "" ? null : event.target.value);
          onCommit();
        }}
      >
        <MixedOption mixed={isMixed(value)} />
        <option value="">None</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <FieldError id={id} error={error} />
    </span>
  );
}
